(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chilli-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const initChilliReviews = (root) => {
    if (!root || root.dataset.cwReviewsReady === 'true') return;

    const track = root.querySelector('[data-cw-reviews-track]');
    const previous = root.querySelector('[data-cw-reviews-prev]');
    const next = root.querySelector('[data-cw-reviews-next]');
    const viewAll = root.querySelector('[data-cw-reviews-view-all]');

    if (!track || !previous || !next) return;

    root.dataset.cwReviewsReady = 'true';

    const move = (direction) => {
      const card = track.querySelector('.cw-reviews__card:not([hidden])');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    if (viewAll) {
      viewAll.addEventListener('click', () => {
        const extraCards = [...root.querySelectorAll('.cw-reviews__card')].slice(8);
        const isExpanded = viewAll.getAttribute('aria-expanded') === 'true';

        extraCards.forEach((card) => {
          card.hidden = isExpanded;
        });
        viewAll.setAttribute('aria-expanded', String(!isExpanded));
        viewAll.textContent = isExpanded ? viewAll.dataset.showLabel : viewAll.dataset.hideLabel;

        if (isExpanded) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        }
      });
    }
  };

  const initAllChilliReviews = (scope = document) => {
    scope.querySelectorAll('[data-cw-reviews]').forEach(initChilliReviews);
  };

  initAllChilliReviews();
  document.addEventListener('shopify:section:load', (event) => initAllChilliReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
